import split from "lodash/fp/split";
import trim from "lodash/fp/trim";
class Controller {
  constructor($mdDialog, latLong, GoogleMaps) {
    "ngInject";
    this.map = {};
    this.address = "";
    this.latLong = Array.isArray(latLong)
      ? latLong
      : [latLong.lat, latLong.lng];
    this.$mdDialog = $mdDialog;
    this.types = ["address"];

    // This one for ng-map
    this.googleMapsUrl = GoogleMaps.getSource();

    this.triggerMapsResizeEvent = (map) =>
      window.google.maps.event.trigger(map, "resize");

    this.getPos = (event) => {
      if (event.latLng) {
        this.latLong = [event.latLng.lat(), event.latLng.lng()];
      } else {
        this.latLong = [event.lat(), event.lng()];
      }

      return this.latLong;
    };

    this.center =
      this.latLong && this.latLong.length
        ? `${this.latLong[0]},${this.latLong[1]}`
        : "30.0444196,31.23571160000006";

    this.zoom = this.latLong && this.latLong.length ? 15 : 4;

    const fixCoordinate = (coordinate) => Number(trim(coordinate));
    const latLngRegex = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;

    const isLatLng = (latLng) => {
      return latLngRegex.test(latLng);
    };

    const setCenter = (location) => {
      this.map.setCenter(location);
      this.map.setZoom(15);
      this.latLong = this.getPos(this.map.getCenter());
    };

    this.placeChanged = function () {
      const place = this.getPlace();
      if (place.geometry) {
        setCenter(place.geometry.location);
      } else {
        const checkLatLng = isLatLng(place.name);

        if (checkLatLng) {
          const coordinates = split(",")(place.name);

          setCenter({
            lat: fixCoordinate(coordinates[0]),
            lng: fixCoordinate(coordinates[1]),
          });
        }
      }
    };

    this.onMapInit = (map) => {
      this.map = map;
      this.triggerMapsResizeEvent(map);
    };
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    if (this.latLong && this.latLong.length > 0) {
      this.$mdDialog.hide(this.latLong);
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/pickLocationMap/dialog/dialog.controller.js